// extracted by mini-css-extract-plugin
export default {"title":"start_title__G60ns","intro":"start_intro__l1Zxc","outro":"start_outro__bMF1g","start_wrapper":"start_start_wrapper__I4MrZ","text_container":"start_text_container__3rm1e"};